import { modalRenderer } from '~/modal/modalRendererRegistry';
import { IntroModalComponent } from './introModal.component';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    Intro: undefined;
  }
}

modalRenderer.register('Intro', IntroModalComponent);
